import _ from "lodash";
import React from "react";
import classNames from "classnames";
import classes from "./AssessmentLibrary.scss";
import PropTypes from "prop-types";
import { getUnitPlanDetailsFromCache } from "IBPlanner/modules/IBGraphqlHelpers";
import { connect } from "react-redux";
import { getUnitPlanResourceLibraryQuery } from "UnitPlans/modules/UnitPlanQuery";
import I18nHOC from "UIComponents/I18nHOC";
import withPusherBind from "UIComponents/PusherConsumerHoc";
import Loading from "UIComponents/Loading";
import withPusherSubscribe from "UIComponents/PusherSubscribeHoc";
import { getUnitPlanResourceLibraryFromCache } from "UnitPlans/modules/UnitPlanGraphqlHelpers";
import {
  deleteAssessment,
  importAssessment,
  gotoAssessmentDetails,
  updateFilters,
  initialState,
} from "Assessments/modules/AssessmentModule";

import { isUserAuthenticatedForAction } from "Login/modules/LoginModule";
import {
  getResourceTypes,
  getResourceTypeItem,
} from "IBPlanner/modules/IBPlannerModule";
import { graphql, compose } from "lib/apolloClient";
import { getPrintFile } from "modules/PrintThunks";
import AssessmentLibraryEdit from "./AssessmentLibraryEdit";
import ItemViewFeed from "UnitPlans/components/IBcomponents/ItemViewFeed";
import { getEntityFlowResourceMultiNodeQuery } from "UnitFlowV3/modules/EntityFlow/Query";
import { getEntityFlowResourceMultiNodeQuery as learningCourseFlowQueries_getEntityFlowResourceMultiNodeQuery } from "UnitFlowV3/modules/LearningCourseFlow/Query";
import ResourceCardV1 from "AppComponents/Cards/ResourceCardV1";
import { colors, fontStyle } from "Constants";
import { getUnitPlanCentralRepoInputAndFilters } from "Courses/modules/utils";
import {
  getResourceNodes,
  getUnitPlanFieldResponseFilter,
} from "UnitPlans/modules/Utils";
import { getIsLearningCoursesEnabledForUnit } from "UnitPlans/modules/UnitViewModeUtils";
import { getSelectedAcademicYearId } from "modules/CommonSelectors";
import { getCurrentAssessmentTypes } from "Platform/modules/PlatformModule";
import { PUSHER_EVENTS, getUnitFlowUtils } from "UnitFlowV3/modules/utils";

const ResourceViewTheme = {
  imageContainer: {
    height: 40,
    width: 40,
  },
  sectionLabel: {
    fontSize: "1.4rem",
    color: colors.textDefault,
    marginBottom: 0,
    ...fontStyle.medium,
  },
  sectionAuthorAndDuration: {
    fontSize: "1.2rem",
    color: colors.textSubtle,
    ...fontStyle.medium,
  },
  sectionItem: {
    alignItems: "center",
    cursor: "pointer",
  },
  sectionItemDetails: {
    padding: "0 12px",
  },
  imageThumbnail: {
    borderRadius: "8px",
  },
};
class AssessmentLibrary extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount = () => {
    const {
      updateFilters,
      groupType,
      assessmentTypes,
      filters,
      mode,
    } = this.props;

    if (
      (filters.groupType !== groupType ||
        _.size(_.difference(assessmentTypes, filters.assessmentTypes))) &&
      _.isEqual(mode, "edit")
    ) {
      updateFilters({ groupType, assessmentTypes, searchText: "" });
    }
  };

  componentWillUnmount = () => {
    const { updateFilters } = this.props;
    updateFilters({ searchText: "" });
  };

  componentDidUpdate = prevProps => {
    const { updateFilters, groupType, assessmentTypes, mode } = this.props;

    if (
      (prevProps.groupType !== groupType ||
        _.size(_.difference(assessmentTypes, prevProps.assessmentTypes))) &&
      _.isEqual(mode, "edit")
    ) {
      updateFilters({ groupType, assessmentTypes, searchText: "" });
    }
  };

  showModal = ({ id, mode }) => {
    const {
      onAssessmentClick,
      gotoAssessmentDetails,
      assessmentTypes,
      groupType,
    } = this.props;
    if (onAssessmentClick) {
      onAssessmentClick({ id, mode });
    } else {
      gotoAssessmentDetails({
        id,
        mode,
        isOpenInNewTab: false,
        resourceType: groupType,
      });
    }
  };

  onViewCardClicked = async ({ id, mode = "view" }) => {
    const { isUserAuthenticatedForAction } = this.props;

    const hasAccess = await isUserAuthenticatedForAction();
    if (!hasAccess) return;
    this.showModal({ id, mode });
  };

  renderViewItem = ({ item }) => {
    const { isToddleLibrary, t, testId } = this.props;

    const customSubTitle = isToddleLibrary ? t("common:le_label") : null;

    return (
      <ResourceCardV1
        item={item}
        showTypeLabel={false}
        imageThumbSize={120}
        theme={ResourceViewTheme}
        key={item.id}
        isToddleLibrary={isToddleLibrary}
        customSubTitle={customSubTitle}
        onContainerClick={() => this.onViewCardClicked({ id: item.id })}
        testId={`${testId}-assessmentLibrary`}
      />
    );
  };

  renderView = () => {
    const {
      assessments,
      getResourceTypes,
      groupType,
      curriculumType,
      isLoading,
      isUnitFlowRevamp,
      isData,
    } = this.props;
    const resources = getResourceTypes({ curriculumType });

    const resource = getResourceTypeItem({
      resources,
      curriculumType,
      groupType,
    });

    const showLoader = !isData && isLoading;

    const itemViewFeedContainerClasses = classNames(
      classes.itemViewFeedContainer,
      {
        [classes.itemViewFeedContainerRevamp]: isUnitFlowRevamp,
      }
    );

    return showLoader ? (
      <Loading />
    ) : (
      <div className={itemViewFeedContainerClasses}>
        <ItemViewFeed
          items={assessments}
          {...this.props}
          renderItem={this.renderViewItem}
          itemText={_.get(resource, "labelWithoutCount", "")}
        />
      </div>
    );
  };

  render() {
    const {
      mode,
      getResourceTypes,
      size,
      groupType,
      curriculumType,
      academicYearId,
      testId,
    } = this.props;

    const resources = getResourceTypes({ curriculumType });

    //TODO: Need to improve curriculumType condition

    const resource = getResourceTypeItem({
      resources,
      curriculumType,
      groupType,
    });

    return mode == "edit" ? (
      <AssessmentLibraryEdit
        size={size}
        {...this.props}
        resource={resource}
        showModal={this.showModal}
        academicYearId={academicYearId}
        testId={`${testId}-assessmentLibrary`}
      />
    ) : (
      this.renderView()
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { groupType, assessmentTypes, mode } = ownProps;
  const {
    isUnitFlowRevampEnabled,
    getUnitFlowFeedVariablesMemoized,
  } = getUnitFlowUtils();

  const userInfo = _.get(state, "login.userInfo", {});
  const selectedCourseId = _.get(
    state,
    "teacher.selected_class.selected_course",
    ""
  );
  const organizationId = _.get(userInfo, "org_id", "");
  const academicYearId = getSelectedAcademicYearId(state);

  const { centralRepoInput } = getUnitPlanCentralRepoInputAndFilters({
    organizationId: organizationId,
    courseId: selectedCourseId,
    academicYearId,
  });

  const responseFilter = getUnitPlanFieldResponseFilter();

  const unitPlanId = ownProps.unitPlanId
    ? ownProps.unitPlanId
    : state.planner.unitPlanData.unitPlanId;

  const collaboratorsFilter = {
    userAcademicYearId: academicYearId,
  };

  const unitPlanDetails = getUnitPlanDetailsFromCache({
    unitPlanId,
    centralRepoInput,
    responseFilter,
    collaboratorsFilter,
    exceptionalCollaboratorsFilter: collaboratorsFilter,
  });
  const unitPlanFields = _.get(unitPlanDetails, "allFields", []);

  const filters = _.isEqual(mode, "edit")
    ? _.get(state, "assessment.filters", {})
    : { groupType, assessmentTypes, searchText: "" };

  const unitPlantitle = _.get(
    _.find(unitPlanFields, { uid: "title" }),
    "value",
    ""
  );
  const curriculumType = _.get(
    unitPlanDetails,
    "curriculumProgram.type",
    "IB_PYP"
  );
  const templateId = _.get(unitPlanDetails, "templateId", null);
  const isUnitFlowRevamp = isUnitFlowRevampEnabled();

  // Variables for Unit Plan Multi Node query
  const unitFlowFilters = _.get(state, "unitFlow.filters", {});
  const multiNodefeedQueryVariables = getUnitFlowFeedVariablesMemoized({
    unitPlanId,
    filters: unitFlowFilters,
    userInfo,
    curriculumType,
  });

  const isLearningCoursesEnabled = getIsLearningCoursesEnabledForUnit();

  return {
    unitPlanId,
    unitPlantitle,
    curriculumType,
    filters,
    organizationId,
    selectedCourseId,
    isUnitFlowRevamp,
    templateId,
    isLearningCoursesEnabled,
    multiNodefeedQueryVariables,
  };
};

const mapActionCreators = {
  deleteAssessment,
  importAssessment,
  getPrintFile,
  getResourceTypes,
  gotoAssessmentDetails,
  isUserAuthenticatedForAction,
  updateFilters,
  getCurrentAssessmentTypes,
};

const getEntityFlowResourceMultiNodeQueryFunc = (query, isEntityFlow) =>
  graphql(query, {
    name: "getEntityFlowResourceMultiNode",
    skip: ({ isUnitFlowRevamp, isLearningCoursesEnabled }) =>
      !isUnitFlowRevamp ||
      (isEntityFlow ? isLearningCoursesEnabled : !isLearningCoursesEnabled),
    options: () => ({
      fetchPolicy: "cache-and-network",
      context: { useHttpLink: true },
      variables: {
        // fetch with empty variables
        // will utilize .refetch method later
        ids: [],
      },
    }),
    props({
      getEntityFlowResourceMultiNode,
      ownProps: { multiNodefeedQueryVariables, onPusherEventTriggered },
    }) {
      return {
        onPusherEventTriggered: (params = {}) => {
          const { event, resourceIds = [] } = params;

          onPusherEventTriggered?.(params);

          if (event === PUSHER_EVENTS.RESOURCE_UPDATE) {
            getEntityFlowResourceMultiNode.refetch({
              ...multiNodefeedQueryVariables,
              ids: resourceIds,
            });
          }
        },
      };
    },
  });

const AssessmentLibraryWrapper = compose(
  I18nHOC({ resource: "common" }),
  connect(mapStateToProps, mapActionCreators),
  graphql(getUnitPlanResourceLibraryQuery, {
    name: "getUnitPlanResourceLibrary",
    skip: ({ unitPlanId }) => !unitPlanId,
    options: ({ unitPlanId, filters }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: unitPlanId,
        filters,
      },
      context: {
        useHttpLink: true,
      },
    }),
    props({
      getUnitPlanResourceLibrary,
      ownProps: {
        unitPlanId,
        curriculumType,
        getCurrentAssessmentTypes,
        onPusherEventTriggered,
      },
    }) {
      const unitPlanDetails = getUnitPlanResourceLibraryFromCache({
        id: unitPlanId,
        filters: initialState.filters,
      });

      const filteredUnitPlanDetails = _.get(
        getUnitPlanResourceLibrary,
        "node",
        {}
      );

      const assessments = getResourceNodes({
        resources: _.get(filteredUnitPlanDetails, "resourceLibrary.edges", []),
        curriculumType,
        nodeName: "node",
        getCurrentAssessmentTypes,
      });

      return {
        onPusherEventTriggered: (params = {}) => {
          const { event, isUnitPlanAssessmentFeedRefetch } = params;

          onPusherEventTriggered?.(params);

          if (
            event === "unitPlanResourceLibraryFeedUpdate" ||
            (event === PUSHER_EVENTS.FEED_UPDATE &&
              isUnitPlanAssessmentFeedRefetch)
          ) {
            getUnitPlanResourceLibrary.refetch();
          }
        },
        isFilteredData: !_.isEmpty(filteredUnitPlanDetails),
        isData: !_.isEmpty(unitPlanDetails),
        isLoading:
          getUnitPlanResourceLibrary["networkStatus"] == 1 ||
          getUnitPlanResourceLibrary["networkStatus"] == 2,
        getUnitPlanResourceLibrary,
        assessments,
      };
    },
  }),
  // used for fetching items on pusher event
  getEntityFlowResourceMultiNodeQueryFunc(
    getEntityFlowResourceMultiNodeQuery,
    true
  ),
  getEntityFlowResourceMultiNodeQueryFunc(
    learningCourseFlowQueries_getEntityFlowResourceMultiNodeQuery,
    false
  ),
  withPusherSubscribe(["getEntityFlowResourceMultiNode"]),
  withPusherSubscribe(["unitPlan"]),
  withPusherBind([
    PUSHER_EVENTS.FEED_UPDATE,
    PUSHER_EVENTS.RESOURCE_UPDATE,
    "unitPlanResourceLibraryFeedUpdate",
  ])
)(AssessmentLibrary);

AssessmentLibraryWrapper.propTypes = {
  label: PropTypes.string,
  subText: PropTypes.string,
  labelStyle: PropTypes.object,
  labelComponent: PropTypes.element,
  name: PropTypes.string,
  errorStyle: PropTypes.object,
  customValidation: PropTypes.func,
  mode: PropTypes.string,
  assessmentTypes: PropTypes.array,
  options: PropTypes.array,
};

AssessmentLibraryWrapper.defaultProps = {
  label: "",
  subText: "",
  labelStyle: {},
  mode: "edit",
  size: "regular",
  groupType: "LEARNING_ENGAGEMENT",
  assessmentTypes: [],
  options: [],
};

export default AssessmentLibraryWrapper;
